export default __webpack_public_path__ + "static/media/healthscan-register-illustration.4d6b0d79.svg";